import React from 'react';
import { connect } from 'react-redux';
import { Switch, Redirect, Route, withRouter } from 'react-router-dom';
import { CssBaseline, Grid, CircularProgress, Typography, Icon } from '@mui/material';
import { AppRoute } from 'components/AppRoute';
import LandingPage from 'components/pages/LandingPage';
import ProductSearchPage from 'components/pages/ProductSearchPage';
import CartPage from 'components/pages/CartPage';
import MainLayout from 'components/MainLayout';
import { fetchSite } from 'actions/SiteActions';
import { fetchCatalogue } from 'actions/ProductActions';
import OrderCardForm from 'components/pages/forms/OrderCardForm';
import CheckoutForm from 'components/pages/forms/CheckoutForm';
import VerifyPage from 'components/pages/VerifyPage';
import PollTransactionPage from 'components/pages/PollTransactionPage';
import ThanksPage from 'components/pages/ThanksPage';
import CheckBalancePage from 'components/pages/CheckBalancePage';
import ContactUsPage from 'components/pages/ContactUsPage';
import CollectionGroupPage from 'components/pages/CollectionGroupPage';
import CollectionPage from 'components/pages/CollectionPage';
import TagPage from 'components/pages/TagPage';
import CustomPage from './pages/CustomPage';
import ConfirmationPage from 'components/pages/ConfirmationPage';
import SitemapPage from 'components/pages/SitemapPage';
import { ensightenView } from 'utils/tracking';

export class Router extends React.Component {
  componentDidMount() {
    if (window.SITE_ID) {
      this.props.fetchSite(window.SITE_ID, this.props.locale);
      this.props.fetchCatalogue(window.SITE_ID, this.props.locale);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.locale !== prevProps.locale) {
      this.props.fetchSite(window.SITE_ID, this.props.locale);
      this.props.fetchCatalogue(window.SITE_ID, this.props.locale);
    }

    // Hack to run ensighten tracking once data is fetched
    if (!this.props.siteFetching && !this.props.productFetching && (prevProps.siteFetching == true || prevProps.productFetching == true)) {
      ensightenView(window.location.pathname, null, this.props.cart, this.props.products, null);
    }
  }

  templateComponent(customPage) {
    if (customPage.template == 'terms_and_conditions') {
      return <CustomPage content={customPage.content} name={customPage.name} page_title={customPage.page_title} description={customPage.description} block_search_engines={customPage.block_search_engines}/>
    } else if (customPage.template == 'contact_us') {
      return <ContactUsPage content={customPage.content} name={customPage.name} page_title={customPage.page_title} description={customPage.description} block_search_engines={customPage.block_search_engines} />
    } else if (customPage.template == 'sitemap') {
      return <SitemapPage name={customPage.name} pageTitle={customPage.page_title} description={customPage.description} block_search_engines={customPage.block_search_engines} />
    }
  }

  render() {
    const { isFetching, site, locale } = this.props;

    if (!window.SITE_ID) {
      return (
        <center className="under-construction">
          <Typography variant="h3" gutterBottom>Under construction</Typography>
          <Icon className="outlined" style={{fontSize: '72px'}}>construction</Icon>
        </center>
      )
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container justifyContent="center">
          {!site ?
            <Grid container spacing={2} justifyContent="center" style={{margin: '75px'}} >
              <CircularProgress />
            </Grid>
          :
            <Switch>
              <AppRoute exact path='/' layout={MainLayout} component={() => <LandingPage site={site} />} />
              <AppRoute exact path='/physical' layout={MainLayout} component={() => <LandingPage site={site} filter="physical" />} />
              <AppRoute exact path='/digital' layout={MainLayout} component={() => <LandingPage site={site} filter="digital" />} />
              {/* This is a bit of a hack since we can't push to a same URL with different query params with current React router version, so we need to redirect all search requests */}
              <Route
                path="/search"
                render={(props) => (
                  <Redirect
                    to={{
                      pathname: "/products",
                      search: props.location.search
                    }}
                  />
                )}
              />
              <AppRoute exact path='/products' layout={MainLayout} component={ProductSearchPage} />
              <AppRoute exact path='/card_designs/:productSlug' layout={MainLayout} component={OrderCardForm} />
              <AppRoute exact path='/cart' layout={MainLayout} component={CartPage} />
              <AppRoute exact path='/checkout' layout={MainLayout} component={CheckoutForm} />
              <AppRoute exact path='/thanks' layout={MainLayout} component={ThanksPage} />
              <AppRoute exact path='/:id/verify' layout={MainLayout} component={VerifyPage} />
              <AppRoute exact path='/:id/result' layout={MainLayout} component={PollTransactionPage} />
              {!site.disable_balance_check &&
                [<AppRoute key={1} exact path='/balance' layout={MainLayout} component={CheckBalancePage} />,
                <AppRoute key={2} exact path='/balance-check' layout={MainLayout} component={CheckBalancePage} />]
              }
              <AppRoute exact path={'/categories/:categoryName'} layout={MainLayout} component={CollectionGroupPage} />
              <AppRoute exact path={'/collections/:collectionSlug'} layout={MainLayout} component={CollectionPage} />
              {site.product_tags_enabled &&
                <AppRoute exact path={'/tags/:tagSlug'} layout={MainLayout} component={TagPage} />
              }
              {site.custom_page_groups.map((group) =>
                group.custom_pages.map((customPage, index) =>
                  customPage.template ?
                    <AppRoute key={index} exact path={'/' + customPage.path} layout={MainLayout} component={() => this.templateComponent(customPage)} />
                  :
                    <AppRoute key={index} exact path={'/' + customPage.path} layout={MainLayout} component={() => <CustomPage content={customPage.content} name={customPage.name} page_title={customPage.page_title} description={customPage.description} block_search_engines={customPage.block_search_engines} />} />
                )
              )}
              <AppRoute exact path='/orders/:reference_number/confirm' layout={MainLayout} component={ConfirmationPage} />
              <Redirect to="/" />
            </Switch>
          }
        </Grid>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...state.site,
    locale: state.locale.locale,
    products: state.product.products,
    cart: state.cart.cart,
    siteFetching: state.site.isFetching,
    productFetching: state.product.isCatalogueFetching
  };
}

const mapDispatchToProps = {
  fetchSite: (id, locale) => fetchSite(id, locale),
  fetchCatalogue: (id, locale) => fetchCatalogue(id, locale)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Router));
